module.exports = __webpack_public_path__ + "5d49234b0f9e85b6ed676e5ea484eb91.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-yoga/1.jpg
// module id = 610
// module chunks = 0